import { Button } from 'admin/components/atoms/Buttons';
import Link from 'admin/components/atoms/Link';
import ApiResults from 'admin/components/molecules/ApiResults';
import BreadCrumb, { Crumb } from 'admin/components/molecules/BreadCrumb';
import useCoupons from 'admin/hooks/useCoupons';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { selectUserPrivateMoney } from '~/javascripts/admin/reducers/user-private-money';
import CouponListForm from './CouponListForm';
import CouponListTable from './CouponListTable';

const crumbs = [
  new Crumb('ホーム', '/', false),
  new Crumb('販促管理', '', true),
  new Crumb('クーポン管理', '', true),
];

const CreateButton = styled(Button)`
  margin-bottom: 1rem;
`;

const CouponWrapper = styled.div`
  margin: 5px;
`;

const CouponList = () => {
  const [isLoading, coupons, pagination, error, getCoupons] = useCoupons();
  const [page, setPage] = useState(1);

  const user = useAppSelector((state) => state.user);
  const selectedPrivateMoney = useAppSelector(selectUserPrivateMoney);
  const isMerchantUser =
    !user.isServiceUser?.() &&
    !!selectedPrivateMoney &&
    !user.isIssuerOfMoney?.(selectedPrivateMoney);

  const handleChangePage = (page) => {
    setPage(page);
  };

  return (
    <>
      <BreadCrumb crumbs={crumbs} />
      {error.message ? <ApiResults messages={[{ text: error.message, isError: true }]} /> : null}
      {!isMerchantUser && (
        <Link to="/promotion/coupons/create">
          <CreateButton>新規作成</CreateButton>
        </Link>
      )}

      <CouponWrapper>
        <CouponListForm fetchCoupons={getCoupons} page={page} />
        <CouponListTable
          coupons={coupons}
          pagination={pagination}
          onChangePage={handleChangePage}
          isLoading={isLoading}
        />
      </CouponWrapper>
    </>
  );
};

export default CouponList;
